import axios from 'axios'
// import requestHeader from './request.header'
import url from './request.url'

export default class AccountApi {

  constructor() {
  }

  signin(creds, callback) {
    // console.log(`[ACCOUNT #API#]`, creds)
    // alert(`[ACCOUNT #API#]`)

    return axios.post(url.application.account.signin, creds).then(res => {
      // console.log(`[ACCOUNT #API#] res`, res)
      // alert(`[ACCOUNT #API#] res`)
      callback(!!res.data ? res.data : {})
    }).catch(error => {
      // console.log(`[ACCOUNT #API#] error`, error)
      // alert(`[ACCOUNT #API#] err`)
      if(!!error && !!error.response) {
        callback(!!error.response.data ? error.response.data : {})
      } else {
        callback({})
      }
    })
  }

  signms(creds, callback) {
    //alert(`[ACCOUNT #API#]`)
    // console.log(`[ACCOUNT #API#]`, creds)
    return axios.post(url.application.account.signms, creds).then(res => {
      callback(!!res.data ? res.data : {})
    }).catch(error => {
      if(!!error && !!error.response) {
        callback(!!error.response.data ? error.response.data : {})
      } else {
        callback({})
      }
    })
  }
}
